import { useState } from "react";


export default function Property({
  setLand,
  setHouse,
  setAppartament,
  setComercial,
  defaultValue,
}) {
  console.log(defaultValue === "house");
  const [isSmall] = useState(window.innerWidth <= 950);
  return (
    <div className="propertyy" style={{ padding: "5px" }}>
      <h5>{isSmall ? "ԳՈՒՅՔԻ Տ." : "ԳՈՒՅՔԻ ՏԵՍԱԿ"}</h5>
      <div className="with">
        <div>
          <input
            onChange={() => {
              setLand(false);
              setHouse(false);
              setAppartament(true);
              setComercial(false);
            }}
            defaultChecked={defaultValue === "apartment" || !defaultValue}
            type="radio"
            name="propertyType"
            id="apartment"
            value="apartment"
          />
          <label htmlFor="apartment">{isSmall ? "ԲՆԱԿ." : "ԲՆԱԿԱՐԱՆ"}</label>
        </div>
        <div>
          <input
            onChange={() => {
              setLand(false);
              setHouse(true);
              setAppartament(false);
              setComercial(false);
            }}
            type="radio"
            name="propertyType"
            id="house"
            value="house"
            defaultChecked={defaultValue === "house"}
          />
          <label htmlFor="house">{isSmall ? "ԱՌԱՆՁ." : "ԱՌԱՆՁՆԱՏՈՒՆ"}</label>
        </div>
        <div>
          <input
            onChange={() => {
              setLand(false);
              setHouse(false);
              setAppartament(false);
              setComercial(true);
            }}
            type="radio"
            name="propertyType"
            id="commercial"
            value="commercial"
            defaultChecked={defaultValue === "commercial"}
          />
          <label htmlFor="commercial">
            {isSmall ? "ԿՈՄ." : "ԿՈՄԵՐՑԻՈՆ ԳՈՒՅՔ"}
          </label>
        </div>
        <div>
          <input
            onChange={() => {
              setLand(true);
              setHouse(false);
              setAppartament(false);
              setComercial(false);
            }}
            type="radio"
            name="propertyType"
            id="land"
            value="land"
            defaultChecked={defaultValue === "land"}
          />
          <label htmlFor="land">{isSmall ? "ՀՈՂ." : "ՀՈՂԱՏԱՐԱԾՔ"}</label>
        </div>
      </div>
    </div>
  );
}

